import { NumericFormatType } from "../models/growthSimulator.models";

export const convertToNumericFormatType = (value: number, prefix?: string, suffix?: string): NumericFormatType => ({
    formattedValue: `${prefix || ''}${value}${suffix || ''}`,
    value: `${value}`,
    floatValue: value,
  })